import { SearchBy } from '@givebacks/api/query';
import { DatesRangeValue } from 'ui';

const serializeString = (value: string, searchBy?: SearchBy) => ({ value, by: searchBy });

const serializeMultiSelect = (list: string[], searchBy?: string) => ({
  value: list?.join(','),
  ...(list.length > 0 ? { by: searchBy ?? 'in' } : {}),
});

const serializeDateRange = (dateRangeValue: DatesRangeValue, searchBy?: SearchBy) => {
  if (dateRangeValue[0] && dateRangeValue[1]) {
    dateRangeValue[1].setHours(23, 59, 59, 999);
    return {
      value: `${dateRangeValue[0]?.toISOString()}|${dateRangeValue[1]?.toISOString()}`,
      by: searchBy ?? 'between',
    };
  }
};

export { serializeDateRange, serializeMultiSelect, serializeString };
